import { motion, useAnimation } from 'framer-motion';
import React, { CSSProperties } from 'react';
import { colors, hexToRgbA } from '../../theme/colors';

const GlowingBarLoadingIndicator = () => {
  const controls = useAnimation();

  const animateBar = async () => {
    await controls.start({
      boxShadow: `0 0 20px ${hexToRgbA(colors.primary, 1)}`,
      opacity: [0.2, 1, 0.2],
      transition: { duration: 2, repeat: Infinity },
    });
  };

  React.useEffect(() => {
    animateBar();
  }, []);

  const containerStyle: CSSProperties = {
    width: '100%',
    height: '3px',
    backgroundColor: 'transparent',
    overflow: 'hidden',
    position: 'relative',
  };

  const glowingBarStyle: CSSProperties = {
    width: '100%',
    height: '100%',
    background: `linear-gradient(90deg, ${hexToRgbA(
      colors.primaryVeryLight,
      0.5,
    )}, ${hexToRgbA(colors.primaryMedium, 1)})`,
    position: 'absolute',
    boxShadow: `0 0 10px ${hexToRgbA(colors.primary, 1)}`,
  };

  return (
    <div style={containerStyle}>
      <motion.div
        style={glowingBarStyle}
        initial={{
          boxShadow: `0 0 10px ${hexToRgbA(colors.primary, 1)}`,
          opacity: 0.1,
        }}
        animate={controls}
      ></motion.div>
    </div>
  );
};

export default GlowingBarLoadingIndicator;
